<template>
	<section class="section">
		<h2 class="title">Сколько это стоит?</h2>

		<div class="cost">
			<Icon name="local:cost" class="icon" />
			<div class="col">
				<div class="row">
					<h3 class="cost-title">Стоимость за 1 кг</h3>
					<b class="cost-val">{{ DELIVERY_COST }} ¥</b>
				</div>

				<p class="row">
					<span>По курсу ЦБ на {{ day }}.{{ month }}.{{ year }}</span>
					<span class="cost-val2">~ {{ delCost }} ₽</span>
				</p>
			</div>
		</div>

		<button type="button" aria-label="Оставить заявку" class="button" @click="handleOrderRequest">
			Оставить заявку
		</button>

		<picture>
			<source srcset="/images/cost-mb.png" media="(max-width: 767px)" />
			<source srcset="/images/cost-lg.png" media="(min-width: 768px)" />
			<img src="/images/cost-mb.png" class="image" alt="Стоимость" loading="lazy" />
		</picture>

		<AppModal v-if="modal" v-model:is-open="modal" modal-title="Оставить заявку">
			<FormOrderRequest @submit-form="modal = false" @close-form="modal = false" />
		</AppModal>
	</section>
</template>

<script setup lang="ts">
	const config = useRuntimeConfig();
	const now = new Date();
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0');
	const day = String(now.getDate()).padStart(2, '0');
	const formattedDate = `${year}-${month}-${day}`;

	const modal = ref(false);

	const url = `${config.public.CURRENCY_API_URL}/currency/logs/${formattedDate}/`;

	const { data } = await useAsyncData<Array<{ id: number; name: string; value: string }>>(
		'currency',
		() => $fetch(url),
		{ default: () => [] }
	);

	const delCost = computed(() => {
		const item = data.value.find((v) => v.name === 'cny');
		const val = Number(item?.value) ?? 0;

		return formatNumber(DELIVERY_COST * val, 0);
	});

	const handleOrderRequest = () => {
		modal.value = true;
	};
</script>

<style lang="scss" scoped>
	.section {
		border-radius: 20px;
		height: 427px;
		max-height: 427px;
		position: relative;
		background: linear-gradient(346.27deg, #8cbae0 54.1%, #5f94c6 74.58%);
		padding: 18px 15px;
		z-index: 1;

		.title {
			color: #ffffff;
			font-weight: 700;
			font-size: 30px;
			line-height: 120%;
			letter-spacing: 0%;
		}

		.image {
			max-height: 202px;
			object-fit: contain;
			object-position: right;
			border-radius: 20px;
			bottom: 0;
			left: 0;
			width: 100%;
			position: absolute;
			z-index: -1;
		}
	}

	.cost {
		margin-top: 26px;
		border-radius: 20px;
		padding: 14px;
		background-color: #ffffff;
		color: #9a9a9a;
		font-family: Nunito;
		font-weight: 500;
		font-size: 16px;
		line-height: 120%;
		letter-spacing: 0%;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;

		.icon {
			display: none;
			color: #6094c6;
			width: 58px;
			height: 58px;
		}

		.col {
			display: flex;
			flex-direction: column;
			gap: 7px;
			flex: 1;
		}

		.row {
			display: flex;
			flex-wrap: nowrap;
			gap: 5px;
			align-items: center;
			justify-content: space-between;
		}

		.cost-title {
			color: #6094c6;
			font-weight: 700;
			font-size: 20px;
			line-height: 120%;
			letter-spacing: 0%;
		}

		.cost-val {
			font-family: Nunito;
			font-weight: 700;
			font-size: 24px;
			line-height: 120%;
			letter-spacing: 0%;
			color: #ff9c00;
			white-space: nowrap;
		}

		.cost-val2 {
			white-space: nowrap;
		}
	}

	.button {
		margin-top: 20px;
	}

	@media screen and (min-width: 768px) {
		.section {
			height: 350px;

			.image {
				left: auto;
				right: 0;
				height: 350px;
				max-height: 350px;
				width: unset;
			}
		}

		.cost {
			width: 50%;
		}

		.button {
			width: 200px;
		}
	}

	@media screen and (min-width: 1240px) {
		.section {
			padding: 50px 70px;

			.title {
				font-size: 45px;
			}
		}

		.cost {
			margin-top: 30px;
			width: 545px;
			font-size: 18px;
			padding: 20px;

			.cost-title {
				font-size: 24px;
			}

			.icon {
				display: block;
			}
		}
	}
</style>
